module.exports = __webpack_public_path__ + "media/CN_002.48ffb7df.mp3";